var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl",
      staticStyle: { "max-height": "fit-content" }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-content",
          staticStyle: { "min-height": "850px" }
        },
        [
          _c("div", { staticClass: "modal-header" }, [
            _c("h5", { staticClass: "modal-title" }, [
              _vm._v(_vm._s(_vm.title))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group form-inline privacy" }, [
              _c(
                "label",
                { staticClass: "p-2", attrs: { for: "termHistory" } },
                [_vm._v(_vm._s(_vm.$t("sdl.common.label.trialHistory")))]
              ),
              _vm._v(" "),
              _c(
                "select",
                {
                  staticClass: "form-control",
                  attrs: { id: "termHistory" },
                  on: { change: _vm.changeTerm }
                },
                _vm._l(_vm.list, function(item) {
                  return _c(
                    "option",
                    { key: item.termsId, domProps: { value: item.termsId } },
                    [_vm._v(_vm._s(item.startDate))]
                  )
                }),
                0
              )
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "close",
                attrs: {
                  type: "button",
                  "data-dismiss": "modal",
                  "aria-label": "Close"
                },
                on: {
                  click: function($event) {
                    return _vm.$emit("close")
                  }
                }
              },
              [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c("div", { domProps: { innerHTML: _vm._s(_vm.content) } }),
            _vm._v(" "),
            _c("p", { staticClass: "mt-4" }, [
              _vm._v(
                _vm._s(_vm.$t("sdl.common.label.enforcementDate")) +
                  " : " +
                  _vm._s(_vm.startDate)
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button", "data-dismiss": "modal" },
                on: {
                  click: function($event) {
                    return _vm.$emit("close")
                  }
                }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("sdl.common.label.close")) +
                    "\n      "
                )
              ]
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6952d96e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6952d96e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/popup/TermPopup.vue
// module id = null
// module chunks = 